import { QUIZ_URL } from "../../constants";
import { apiSlice } from "../apiSlice";

const quizUsersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    quizLogin: builder.mutation({
      query: (data) => ({
        url: `${QUIZ_URL}/login`,
        method: 'POST',
        body: data
      }),
    }),
    quizLogout: builder.mutation({
      query: () => ({
        url: `${QUIZ_URL}/logout`,
        method: 'POST'
      })
    }),
    getQuizUserGroups: builder.query({
      query: () => ({
        url: `${QUIZ_URL}/profile/groups`,
      }),
      keepUnusedDataFor: 5,
      providesTags: ['QuizGroup'],
    }),
    getScoreboardTotals: builder.query({
      query: () => ({
        url: `${QUIZ_URL}/profile/scoreboard/totals`,
      }),
      keepUnusedDataFor: 5,
      providesTags: ['Scoreboard'],
    }),
    getUserChallenges: builder.query({
      query: () => ({
        url: `${QUIZ_URL}/profile/challenges/all`,
      }),
      keepUnusedDataFor: 5,
      providesTags: ['Challenges'],
    }),
    getCompletedQuizById: builder.query({
      query: (quiz_id) => ({
        url: `${QUIZ_URL}/profile/scoreboard/completed/${quiz_id}`,
      }),
      keepUnusedDataFor: 5,
      providesTags: ['Scoreboard'],
    }),
    quizRegister: builder.mutation({
        query: (data) => ({
        url: `${QUIZ_URL}/register`,
        method: 'POST',
        body: data,
        }),
    }),
    updateQuizProfile: builder.mutation({
      query: (data) => ({
        url: `${QUIZ_URL}/profile`,
        method: 'PUT',
        body: data
      })
    }),
    gradeQuiz: builder.mutation({
      query: (data) => ({
        url: `${QUIZ_URL}/profile/grade_quiz`,
        method: 'PUT',
        body: data
      })
    }),
    joinGroup: builder.mutation({
      query: (data) => ({
        url: `${QUIZ_URL}/profile/group`,
        method: 'PUT',
        body: data
      })
    }),
    deleteUser: builder.mutation({
      query: () => ({
        url: `${QUIZ_URL}/profile`,
        method: 'DELETE',
      })
    }),
  }),
});

export const { 
    useQuizLoginMutation, 
    useQuizLogoutMutation, 
    useLazyGetQuizUserGroupsQuery,
    useLazyGetScoreboardTotalsQuery,
    useLazyGetCompletedQuizByIdQuery,
    useLazyGetUserChallengesQuery,
    useUpdateQuizProfileMutation, 
    useGradeQuizMutation,
    useJoinGroupMutation,
    useQuizRegisterMutation, 
    useDeleteUserMutation,
} = quizUsersApiSlice;
